const warriorsSubtypes = ['fighter', 'shooter', 'flyer'];

export default warriorsSubtypes;
